/**
 * @file Constants — publicationFileUpload. Max size for publication details `uploadPublicationFile` (10 MB). */

export const PUBLICATION_FILE_MAX_BYTES = 10 * 1024 * 1024;

/** Exported const — PUBLICATION FILE MAX SIZE LABEL. */
export const PUBLICATION_FILE_MAX_SIZE_LABEL = "10 MB";

/** Exported function — validate Publication File Size. */
export function validatePublicationFileSize(file: File): string | null {
  if (file.size > PUBLICATION_FILE_MAX_BYTES) {
    return `File must be ${PUBLICATION_FILE_MAX_SIZE_LABEL} or smaller (selected: ${formatFileSize(file.size)}).`;
  }
  return null;
}

/** Exported function — format File Size. */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
